import { dailyViewForemanWidth, foremanWidth as width } from '@utils/consts';
import { SchedulerGridCell } from '../../cell';
import { Foreman } from '@components/ui/foreman';
import { SchedulerGridForemanProps } from './types';
import { cn } from '@utils/cn';
import { Conflict } from '@components/schedules/dialogs/internal/publish/types';

export const SchedulerGridForeman = ({
  data,
  first,
  last,
  lastRow,
  customWidth = false,
}: SchedulerGridForemanProps) => {
  const conflicts =
    data?.schedules
      ?.flat()
      .map((el) => el.conflicts)
      .flat()
      .filter(Boolean) || [];

  return (
    <SchedulerGridCell
      className={cn([
        'border-l-0 p-2 h-16',
        !lastRow ? 'border-b' : 'after:hidden',
        !last && 'border-b-transparent',
      ])}
      style={{ width: customWidth ? dailyViewForemanWidth : width }}>
      {first ? <Foreman data={data} conflicts={(conflicts as Conflict[]) || []} /> : null}
    </SchedulerGridCell>
  );
};
